import { render, staticRenderFns } from "./PaymentDebitsNewForm.vue?vue&type=template&id=4a166626"
import script from "./PaymentDebitsNewForm.vue?vue&type=script&lang=js"
export * from "./PaymentDebitsNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports